"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _SearchBar = _interopRequireDefault(require("../Header/SearchBar"));
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
require("./HeaderSearchBar.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var HeaderSearchBar = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(HeaderSearchBar, _Component);
  function HeaderSearchBar(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.checkScreenSize = function () {
      var isMobile = _screenSizes.default.isMobile();
      _this.state.isMobile !== isMobile && _this.setState({
        isMobile: isMobile
      });
    };
    _this.state = {
      isMobile: _screenSizes.default.isMobile()
    };
    return _this;
  }
  var _proto = HeaderSearchBar.prototype;
  _proto.componentDidMount = function componentDidMount() {
    // this is for desktop
    window.addEventListener('resize', this.checkScreenSize); // this is for iPad orientation

    window.addEventListener('orientationchange', this.checkScreenSize);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
    window.removeEventListener('orientationchange', this.checkScreenSize);
  };
  _proto.render = function render() {
    var mobileView = _react.default.createElement(_react.default.Fragment, null);
    var defaultview = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_SearchBar.default, (0, _extends2.default)({}, this.props, {
      isMobile: this.props.showBar
    })));
    return this.state.isMobile && !this.props.showBar ? mobileView : defaultview;
  };
  return HeaderSearchBar;
}(_react.Component);
var _default = HeaderSearchBar;
exports.default = _default;
module.exports = exports["default"];